import { CustomElement, OverrideCustomElementConfig } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedWebComponentOptions, WebComponentOptions } from "@cervval.js/client-html5-core/src/components/typedWebComponentOptions.decorator";
import { FLEX_CONTAINER, FLEX_ITEM_AUTO, H_100, W_100 } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { anyReallyAny } from "@cervval.js/common/tools";
import {
    CjsSmartTable,
    SINGLE_COLUMN_UID, SmartTableOnClickEvent,
    SmartTableOptions,
    defaultSmartTableOptions
} from "../smartTable/smartTable";
import { SmartTableStyle } from "../smartTable/smartTableStyle.helper";

export type SmartListOnClickEvent<ItemData> = SmartTableOnClickEvent<ItemData>;
export type SmartListOptions<ItemData = anyReallyAny> = SmartTableOptions<ItemData>

export const defaultSmartListOptions: SmartListOptions = {

    ...defaultSmartTableOptions,

    /** Based height of smartList rows */
    rowHeight: 30,

    /** Fix column layout */
    columnsLayout: "fixed",

    /** Disable cssStyle */
    cssStyle: SmartTableStyle.NONE,

    /** No stripped rows */
    disableStrippedRows: true,

    /** Default: disable smartListHeader */
    disableHeader: true,

    /** Default: SmartList have no border */
    border: {
        borderLess: true
    },

    /**
     * Default: SmartList only have one column
     * Dev can change this config 
     */
    columns: [{
        uid: SINGLE_COLUMN_UID,
        resizeDisabled: true
    }]
};

@CustomElement({
    name: "cjs-smart-list",
    style: require("./smartList.scss"),
    // uses template from smartTable.html
    elementCssClasses: [FLEX_CONTAINER, FLEX_ITEM_AUTO, W_100, H_100, "cjs-smart-table", "head-border-less"]// head-border-less => do not display border under filter
})
export class CjsSmartList<ItemData = anyReallyAny> extends CjsSmartTable<ItemData> {

    @TypedWebComponentOptions(defaultSmartListOptions)
    public override readonly options!: WebComponentOptions<SmartListOptions<ItemData>>;

    constructor(options?: Partial<SmartListOptions<ItemData>>, customElementOptions?: OverrideCustomElementConfig) {
        super(options, customElementOptions);
    }

}
